import { Glossary } from 'src/app/shared/models/glossary.model';
import { Translation } from 'src/app/shared/models/translation.model';
import { Note } from 'src/app/shared/models/note.model';
import { Attachment } from 'src/app/shared/models/attachment.model';
import { orderByModel } from 'src/app/shared/models/filter-data/order-by.model';
import { SingleFilter } from 'src/app/shared/models/filter-data/single-filter.model';
import { OperatorFilter } from 'src/app/shared/models/filter-data/operator-filter.model';

/**Interfaccia dello stato dell'applicazione per la sezione glossari */
export interface State {
    /**Elenco delle voci di glossario esistenti */
    elencoVociGlossario: Glossary[];
    /**Elenco delle voci di glossario per la tabella nel modale cerca glossario */
    elencoVociGlosModale: Glossary[];
    /**Voce di glossario selezionata */
    voceSelezionata: Glossary;
    /**Array delle voci glossario in selezione secondaria */
    secondarySelections: Glossary[];
    /**Elenco dei riferimenti */
    riferimentiSelezione: Translation[];
    /**Elenco dei riferimenti a voci che riferiscono la voce selezionata come vedi anche */
    seeAlsoIncomeTranslationsSelezione: Translation[];
    /**Elenco dei vedi anche */
    vediAncheSelezione: Glossary[];
    /**Array dei filtri applicati alla tabella glossari principale */
    elencoFiltriVoci: (SingleFilter | OperatorFilter);
    /**Array dei filtri applicati alla tabella glossari del modale cerca glossario */
    elencoFiltriVociModale: (SingleFilter | OperatorFilter);
    /**Ordinamento delle voci in tabella principale */
    ordinamentoVoci: orderByModel[];
    /**Riga iniziale (inclusa) dell'intervallo di voci recuperate in tabella principale */
    fromRow: number;
    /**Riga iniziale (inclusa) dell'intervallo di voci recuperate in tabella modale */
    fromRowModal: number;
    /**Riga finale (esclusa) dell'intervallo di voci recuperate in tabella principale */
    toRow: number;
    /**Riga finale (esclusa) dell'intervallo di voci recuperate in tabella modale */
    toRowModal: number;
    /**Conteggio totale delle voci recuperabili per parametri di filtro dati in tabella principale */
    totalCount: number;
    /**Conteggio totale delle voci recuperabili per parametri di filtro dati in tabella modale */
    totalCountModal: number;
    /**Se la tabella principale è in caricamento o meno */
    isLoadingTabellaVoci: boolean;
    /**Definisce se è in caricamento o meno la tabella voci di glossario del modale */
    isLoadingTabVociModale: boolean;
    /**Definisce se visualizzare o meno il pannello di aggiunta di una nuova voce */
    displayAdd: boolean;
    /**Elenco di note a un riferimento/traduzione */
    refDetailsNotes: Note[];
    /**Elenco di glossari taggati in un riferimento/traduzione */
    refDetailsGlossaries: Glossary[];
    /**Allegato al glossario selezionato */
    voceSelezionataAllegato: Attachment;
    /**Elenco di glossari che costituiscono lo storico delle versioni di una voce selezionata */
    voceSelezionataHistory: Glossary[];
    /**Definisce se debba essere visualizzato o meno il modale di storico */
    isHistoryDisplayed: boolean;
}

/**Stato iniziale della sezione Glossari dell'applicazione */
export const initialState: State = {} as State;